// src/types/finance.ts

export enum ExpenseCategory {
  RENT = 'rent',
  UTILITIES = 'utilities',
  SUPPLIES = 'supplies',
  SALARIES = 'salaries',
  MARKETING = 'marketing',
  MAINTENANCE = 'maintenance',
  OTHER = 'other',
}

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  [ExpenseCategory.RENT]: 'إيجار',
  [ExpenseCategory.UTILITIES]: 'مرافق',
  [ExpenseCategory.SUPPLIES]: 'مستلزمات',
  [ExpenseCategory.SALARIES]: 'رواتب',
  [ExpenseCategory.MARKETING]: 'تسويق',
  [ExpenseCategory.MAINTENANCE]: 'صيانة',
  [ExpenseCategory.OTHER]: 'أخرى',
};

export const EXPENSE_CATEGORY_COLORS: Record<ExpenseCategory, string> = {
  [ExpenseCategory.RENT]: '#6366F1',
  [ExpenseCategory.UTILITIES]: '#F59E0B',
  [ExpenseCategory.SUPPLIES]: '#10B981',
  [ExpenseCategory.SALARIES]: '#3B82F6',
  [ExpenseCategory.MARKETING]: '#EC4899',
  [ExpenseCategory.MAINTENANCE]: '#8B5CF6',
  [ExpenseCategory.OTHER]: '#6B7280',
};

export interface Expense {
  id: string;
  restaurantId: string;
  category: ExpenseCategory;
  description: string;
  amount: number;
  date: string;
  notes?: string;
  createdByUserId?: string;
  createdBy?: {
    id: string;
    username: string;
    role: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ExpenseSummary {
  total: number;
  byCategory: Array<{
    category: ExpenseCategory;
    total: number;
    count: number;
  }>;
}

export interface ShiftReport {
  id: string;
  restaurantId: string;
  userId: string;
  shiftStart: string;
  shiftEnd?: string | null;
  totalOrders: number;
  totalRevenue: number;
  cashCollected?: number | null;
  notes?: string;
  status: 'open' | 'closed';
  user?: {
    id: string;
    username: string;
    role: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ProfitLossReport {
  period: string;
  startDate: string;
  endDate: string;
  revenue: number;
  cashRevenue: number;
  platformNetRevenue: number;
  platformSettled: number;
  platformPending: number;
  cogs: number;
  grossProfit: number;
  expenses: {
    total: number;
    byCategory: Array<{
      category: ExpenseCategory;
      total: number;
    }>;
  };
  netProfit: number;
  profitMargin: number;
}

export interface CashRegister {
  id: string;
  restaurantId: string;
  cashierId: string;
  openedByUserId: string;
  closedByUserId?: string | null;
  openedAt: string;
  closedAt?: string | null;
  openingBalance: number;
  expectedBalance?: number | null;
  actualBalance?: number | null;
  difference?: number | null;
  totalSales: number;
  totalOrders: number;
  cashPayments: number;
  otherPayments: number;
  refunds: number;
  notes?: string;
  status: 'open' | 'closed';
  cashier?: {
    id: string;
    username: string;
    role: string;
  };
  openedBy?: {
    id: string;
    username: string;
    role: string;
  };
  closedBy?: {
    id: string;
    username: string;
    role: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}
